<div class="documents">
    <div class="documents-header">
        <div class="header-title">
            <h3>{{ 'NEXT_STEPS.DOCUMENTS.HEADER.TITLE' | translate }}</h3>
            <div class="title-description">
                {{ 'NEXT_STEPS.DOCUMENTS.HEADER.DESCRIPTION' | translate }}
            </div>
        </div>
        <div class="header-toolbar">
            <a mat-stroked-button color="primary" [disabled]="!canSendEmail" [href]="downloadSelectionUrl()">
                <mat-icon>archive</mat-icon>
                {{ 'NEXT_STEPS.DOCUMENTS.HEADER.TOOLBAR.DOWNLOAD' | translate }}
            </a>
            <button mat-stroked-button color="primary" [disabled]="!canSendEmail" (click)="sendMail()">
                <mat-icon>mail_outline</mat-icon>
                {{ 'NEXT_STEPS.DOCUMENTS.HEADER.TOOLBAR.SEND' | translate }}
            </button>
        </div>
    </div>
    <div class="documents-content">
        <div class="content-attachments">
            <div class="attachments-table">
                <div class="table-header">
                    <mat-checkbox
                        color="primary"
                        class="select-all"
                        [checked]="isAllSelected()"
                        [indeterminate]="isIndeterminate()"
                        (change)="toggleAll()"
                        [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                        >{{ 'NEXT_STEPS.LABEL.SELECT_ALL' | translate }}</mat-checkbox
                    >
                </div>

                <div class="table-item" *ngFor="let quotePdfDownload of quotePdfDownloads">
                    <mat-checkbox
                        color="primary"
                        class="checked"
                        [checked]="true"
                        [disabled]="true"
                        [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                        >{{ 'NEXT_STEPS.LABEL.PDF.' + quotePdfDownload.type | translate }} PDF</mat-checkbox
                    >
                    <app-document-actions
                        [model]="quotePdfDownload"
                        [download]="true"
                        [inline]="true"
                    ></app-document-actions>
                </div>

                <div [formGroup]="schemeForm" *ngIf="isSchemesAvailable" class="table-group">
                    <div class="table-item">
                        <mat-checkbox
                            [checked]="isAllSchemesSelected()"
                            [indeterminate]="isSchemesIndeterminate()"
                            (change)="toggleAllSchemes()"
                            [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                            >{{ 'NEXT_STEPS.LABEL.SCHEMES' | translate }}</mat-checkbox
                        >
                    </div>
                    <ng-container *ngFor="let scheme of schemeIds?.primary">
                        <div class="table-item item-inserted" *ngFor="let type of schemeTypes">
                            <mat-checkbox
                                color="primary"
                                [formControlName]="schemeControlName(scheme, type)"
                                [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                            >
                                {{
                                    'NEXT_STEPS.LABEL.SCHEME_TYPES.' + type.toUpperCase()
                                        | translate : { scheme: this.scheme }
                                }}
                            </mat-checkbox>
                            <app-document-actions
                                [model]="schemeDownloadUrl(scheme, type)"
                                [download]="true"
                                [inline]="true"
                            ></app-document-actions>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="schemeIds?.secondary?.length">
                        <div class="table-item item-inserted">
                            {{ 'NEXT_STEPS.LABEL.SECONDARY_SCHEMES' | translate }}
                        </div>
                        <ng-container *ngFor="let scheme of schemeIds?.secondary">
                            <div class="table-item item-inserted" *ngFor="let type of schemeTypes">
                                <mat-checkbox
                                    color="primary"
                                    [formControlName]="schemeControlName(scheme, type)"
                                    [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                                    >{{
                                        'NEXT_STEPS.LABEL.SCHEME_TYPES.' + type.toUpperCase()
                                            | translate : { scheme: this.scheme }
                                    }}
                                </mat-checkbox>
                                <app-document-actions
                                    [model]="schemeDownloadUrl(scheme, type)"
                                    [download]="true"
                                    [inline]="true"
                                ></app-document-actions>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="table-item" *ngIf="hasConfiguration && energyLabelRelevant">
                    <mat-checkbox
                        color="primary"
                        [disabled]="disableEnergyLabelCheckbox"
                        [(ngModel)]="energyLabelSelected"
                        [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                        >{{ 'NEXT_STEPS.LABEL.ENERGY_LABEL' | translate }}
                    </mat-checkbox>
                    <app-document-actions
                        [model]="energyLabelPdfDownload"
                        [download]="true"
                        [inline]="true"
                    ></app-document-actions>
                </div>
                <div class="table-item" *ngFor="let exportFormat of availableExportFormats">
                    <mat-checkbox
                        color="primary"
                        [checked]="isExportFormatSelected(exportFormat)"
                        (change)="onExportFormatSelected($event, exportFormat)"
                        [matTooltip]="'NEXT_STEPS.TOOLTIP.SELECT' | translate"
                        >{{ exportFormat.replace('_', ' ') }}</mat-checkbox
                    >
                    <app-document-actions
                        [model]="exportFormatDownloadUrl(exportFormat)"
                        [download]="true"
                    ></app-document-actions>
                </div>

                <div [formGroup]="attachmentForm" class="table-group" *ngIf="uploadAttachments.length">
                    <div class="table-item" *ngFor="let attachment of uploadAttachments">
                        <mat-checkbox color="primary" [formControlName]="attachment.id">{{
                            attachment.filename
                        }}</mat-checkbox>
                        <app-document-actions
                            [model]="setDownloadUrl(attachment.documentUri)"
                            [download]="true"
                            [inline]="true"
                        ></app-document-actions>
                    </div>
                </div>
                <div [formGroup]="additionalAttachmentsForm" class="table-group" *ngIf="additionalAttachments.length">
                    <div class="table-item" *ngFor="let attachment of additionalAttachments">
                        <mat-checkbox color="primary" [formControlName]="attachment.id">{{
                            attachment.name
                        }}</mat-checkbox>
                        <app-document-actions
                            [model]="attachment.url"
                            [download]="true"
                            [inline]="false"
                        ></app-document-actions>
                    </div>
                </div>
                <div class="table-item" *ngIf="emsSchemeUrl">
                    <div class="label indented">{{ 'NEXT_STEPS.LABEL.EMS_SCHEME' | translate }}</div>
                    <app-document-actions [inline]="true" [model]="emsSchemeUrl"></app-document-actions>
                </div>
            </div>
        </div>
        <div class="content-uploader">
            <div class="uploader-upload">
                <div class="upload-header">
                    {{ 'NEXT_STEPS.DOCUMENTS.UPLOADER.HEADER' | translate }}
                </div>
                <div class="upload-dropzone">
                    <input
                        type="file"
                        multiple
                        ngFileSelect
                        [options]="options"
                        [uploadInput]="startUpload"
                        (uploadOutput)="onUpload($event)"
                        [attr.accept]="options.allowedContentTypes.join()"
                        #input
                    />
                    <div class="dropzone-button">
                        {{ 'NEXT_STEPS.DOCUMENTS.UPLOADER.SELECT' | translate }}
                    </div>
                </div>
                <div class="upload-storage" *ngIf="atLeastOneFileUploaded()">
                    <div
                        class="storage-item"
                        [class.queued]="uploadFile.queued"
                        [class.uploading]="uploadFile.uploading"
                        [class.uploaded]="uploadFile.control?.value"
                        [class.dragging]="dragging"
                        [class.error]="uploadFile.control.hasError('max') || uploadFile.control.hasError('upload')"
                        *ngFor="let uploadFile of uploadFileControls"
                    >
                        <div class="storage-progress">
                            <div class="progress-details">
                                <div class="progress-icon">
                                    <mat-spinner [diameter]="24"></mat-spinner>
                                </div>
                                <div class="progress-content">
                                    {{ 'NEXT_STEPS.UPLOAD.UPLOADING' | translate : uploadFile.uploading }}
                                </div>
                            </div>
                            <div class="progress-actions">
                                <button mat-icon-button (click)="cancel(uploadFile)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="storage-queue" *ngIf="uploadFile.control?.valid">
                            <div class="queue-icon">
                                <mat-spinner [diameter]="24"></mat-spinner>
                            </div>
                            <div class="queue-content">
                                {{ 'NEXT_STEPS.UPLOAD.QUEUE' | translate }}
                            </div>
                        </div>
                        <div class="storage-file">
                            <div class="file-details">
                                <div class="details-name">
                                    <span *ngIf="uploadFile.deleting">
                                        {{ 'NEXT_STEPS.UPLOAD.DELETING' | translate : uploadFile.control?.value }}
                                    </span>
                                    <span *ngIf="!uploadFile.deleting">
                                        {{ 'NEXT_STEPS.UPLOAD.UPLOADED' | translate : uploadFile.control?.value }}
                                    </span>
                                </div>
                            </div>
                            <ng-container *ngIf="uploadFile.file && !uploadFile.file.nativeFile">
                                <div class="file-actions">
                                    <button
                                        mat-icon-button
                                        (click)="deleteAttachment(uploadFile)"
                                        [disabled]="uploadInProgress()"
                                        [matTooltip]="'NEXT_STEPS.UPLOAD.TOOLTIP.DELETE' | translate"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                        <div *ngIf="uploadFile.control.hasError('max')" class="storage-error">
                            {{ 'NEXT_STEPS.UPLOAD.ERROR.MAX' | translate : uploadFile.control?.errors?.max }}
                        </div>
                        <div *ngIf="uploadFile.control.hasError('upload')" class="storage-error">
                            {{ 'NEXT_STEPS.UPLOAD.ERROR.UPLOAD' | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="uploader-hint">
                <div class="default-hint">
                    <div class="hint-icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <div class="hint-content">
                        <div class="content-description">
                            {{ 'NEXT_STEPS.UPLOAD.HINT.VIBOOKS' | translate }}
                        </div>
                        <div class="content-action">
                            <a [href]="getViBooksUrl()" mat-button color="primary" target="_blank">
                                {{ 'NEXT_STEPS.UPLOAD.LINK.VIBOOKS' | translate }}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
